import PropTypes from 'prop-types';

// project-imports
import SimpleBarScroll from 'components/third-party/SimpleBar';
import Navigation from '../DrawerContent';

export default function VerticalDrawerContent({ selectedItems, setSelectedItems }) {
  return (
    <div style={{ height: 'calc(100vh - 74px)', display: 'flex', flexDirection: 'column' }}>
      <SimpleBarScroll style={{ flex: 1 }}>
        <Navigation selectedItems={selectedItems} setSelectedItems={setSelectedItems} />
      </SimpleBarScroll>
      <div
        style={{
          padding: '14px 20px',
          borderTop: '1px solid rgba(34, 197, 94, 0.08)',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: '0.02em', lineHeight: 1 }}>
            <span style={{ color: 'var(--pc-sidebar-main-active-color, #0f172a)' }}>Fuzz</span>
            <span style={{ color: '#22c55e' }}>Scan</span>
            <span style={{ color: 'var(--fz-text-muted, #64748b)', marginLeft: 5, fontWeight: 600, fontSize: 11 }}>Platform</span>
          </div>
          <div style={{ fontSize: 10, color: 'var(--fz-text-secondary, #94a3b8)', marginTop: 3 }}>
            v1.0.0
          </div>
        </div>
      </div>
    </div>
  );
}

VerticalDrawerContent.propTypes = { selectedItems: PropTypes.any, setSelectedItems: PropTypes.oneOfType([PropTypes.func, PropTypes.any]) };
